import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { FaGlobe, FaApple, FaGooglePlay, FaGithub } from 'react-icons/fa';

const ProjectCard = ({ project }) => {
  const { t } = useTranslation();
  const [isExpanded, setIsExpanded] = useState(false);

  const {
    titleKey,
    descriptionKey,
    image,
    tags,
    links
  } = project;

  const iconSize = 20;

  const title = titleKey ? t(titleKey) : project.title;
  const description = descriptionKey ? t(descriptionKey) : project.description;

  // Limite de caracteres antes de mostrar o "ver mais"
  const DESCRIPTION_LIMIT = 150;
  const isLongDescription = description?.length > DESCRIPTION_LIMIT;

  const displayedDescription =
    isLongDescription && !isExpanded
      ? `${description.slice(0, DESCRIPTION_LIMIT).trim()}...`
      : description;

  return (
    <div className="project-card">
      <div className="project-image">
        <img src={image} alt={title} />
      </div>

      <div className="project-content">
        <h3>{title}</h3>
        <p>
          {displayedDescription}
          {isLongDescription && (
            <button
              type="button"
              className="read-more-btn"
              onClick={() => setIsExpanded((prev) => !prev)}
            >
              {isExpanded
                ? t('projects.readLess')
                : t('projects.readMore')}
            </button>
          )}
        </p>

        <div className="project-tags">
          {tags.map((tag, index) => (
            <span key={index} className="tag">{tag}</span>
          ))}
        </div>

        <div className="project-links">
          {links.appstore && (
            <a
              href={links.appstore}
              target="_blank"
              rel="noopener noreferrer"
              className="link-btn appstore"
              title={t('projects.links.appstore')}
            >
              <FaApple size={iconSize} />
              <span>{t('projects.links.appstore')}</span>
            </a>
          )}

          {links.playstore && (
            <a
              href={links.playstore}
              target="_blank"
              rel="noopener noreferrer"
              className="link-btn playstore"
              title={t('projects.links.playstore')}
            >
              <FaGooglePlay size={iconSize} />
              <span>{t('projects.links.playstore')}</span>
            </a>
          )}

          {links.website && (
            <a
              href={links.website}
              target="_blank"
              rel="noopener noreferrer"
              className="link-btn website"
              title={t('projects.links.website')}
            >
              <FaGlobe size={iconSize} />
              <span>{t('projects.links.website')}</span>
            </a>
          )}
        </div>
      </div>
    </div>
  );
};

export default ProjectCard;